import React from 'react';
import Lottie from 'react-lottie';
import './Voucher_Lottie.css';
import * as animationData from './Voucher_Lottie.json';

function Voucher_Lottie(){
    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: animationData,
        rendererSettings: {
          preserveAspectRatio: "xMidYMid slice"
        }
      };
    
    return (
      <section className='main'>
            <div className='Voucher_Lottie_icon'>
                <Lottie className="me-auto"
                options={defaultOptions}
                // height={60}
                // width={60}          
                />       
        </div>
      </section>
    );
}
export default Voucher_Lottie;